module.exports = __webpack_public_path__ + "static/media/mission.ef016242.png";